import classnames from 'classnames'
import _ from 'lodash'
import { Button } from 'opensolar-ui'
import { FC, useState } from 'react'
import { TextInput, useTranslate } from 'react-admin'
import { useField, useForm } from 'react-final-form'
import { tableStyles } from 'resources/utilityTariffs/styles'

type Props = {
  rateFieldPath: string
  disabled?: boolean
}

export const ChargeHeadlineDescription: FC<Props> = ({ rateFieldPath, disabled }) => {
  const translate = useTranslate()
  const classes = tableStyles()
  const form = useForm()
  const descriptionSourcePath = `${rateFieldPath}.description`
  const [userOpenedEditor, setUserOpenedEditor] = useState(false)

  const {
    input: { value: storedValue },
  } = useField(descriptionSourcePath, { subscription: { value: true } })

  const hasSavedNote = typeof storedValue === 'string' ? storedValue.trim().length > 0 : Boolean(storedValue)

  if (disabled && !hasSavedNote) {
    return null
  }

  const showingNoteEditor = disabled ? hasSavedNote : hasSavedNote || userOpenedEditor

  return (
    <div style={{ marginBottom: showingNoteEditor ? 10 : 12, width: '100%' }}>
      {!showingNoteEditor && (
        <Button
          color="inherit"
          size="small"
          style={{ textTransform: 'none', padding: '0 8px', minHeight: 28, fontSize: 13 }}
          onClick={() => setUserOpenedEditor(true)}
        >
          {translate('Add charge description')}
        </Button>
      )}
      {showingNoteEditor && (
        <TextInput
          fullWidth
          multiline
          minRows={2}
          maxRows={2}
          className={classnames(classes.rateInput, classes.rateRow)}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          label={translate('Charge description')}
          placeholder={translate('Optional note shown beneath this charge on customer proposals when filled in.')}
          helperText={false}
          source={descriptionSourcePath}
          disabled={disabled}
          options={{
            InputProps: {
              style: { backgroundColor: '#fff' },
              onBlur: () => {
                const latest = _.get(form.getState().values, descriptionSourcePath)
                if (!String(latest ?? '').trim()) {
                  setUserOpenedEditor(false)
                }
              },
            },
          }}
        />
      )}
    </div>
  )
}
